export default function loading() {
  const kv = document.getElementById('js-kvTOP');
  let windowHeight;

  if (kv === null) return;

  function addClassBody() {
    const body = document.querySelector('body');
    windowHeight = window.scrollY || window.pageYOffset;
    body.style.top = `-${windowHeight}px`;
    body.classList.add('_fixed');
  }

  function removeClassBody() {
    const body = document.querySelector('body');
    body.style.top = '';
    body.classList.remove('_fixed');
    window.scrollTo(0, windowHeight);
  }

  function loadedFunc() {
    kv.classList.add('_loaded');
  }

  function notFirstAccessFunc() {
    kv.classList.add('_notTransition');
  }

  if (navigator.cookieEnabled) {
    if (document.cookie.indexOf('showLoading=false') === -1) {
      // 初回アクセス（初回アクセスから1日経過でCookie削除）
      const date = new Date();
      date.setDate(date.getDate() + 1);
      document.cookie = 'SameSite=Lax';
      document.cookie = `showLoading=false; expires=${date.toUTCString()};`;
    } else {
      // 2回目以降のアクセス
      notFirstAccessFunc();
      loadedFunc();
    }
  }

  window.addEventListener('load', () => {
    loadedFunc();
    removeClassBody();
  });
  addClassBody();
}
